import { pathJoin } from 'src/reducers/routing/utils'

export const createHaulerDetailViewRoutesMap = (prefix: string) => ({
  configuration: pathJoin(prefix)('configuration').chain,
  pricing: pathJoin(prefix)('pricing').chain,
})
